


















import { Component, Vue, Emit } from 'vue-property-decorator'
import { QueryConfigById, AddSysConfig, UpdateSysConfig } from '@/api'
import { Message } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import constan from '@/utils/constant'
import { VImageUpload } from '@/components/upload'

@Component({
  components: { VImageUpload }
})
export default class EdittSysConfigDialog extends Vue {
  private show = false
  private data: any = {
    configParam: undefined,
    configValue: undefined,
    note: undefined,
  }
  private requiredRule = {
    required: true,
    message: '不能为空',
    trigger: 'blur'
  }
  private rules = {
    configParam: [this.requiredRule],
    configValue: [this.requiredRule]
  }
  private type = 'add'

  private get isPreview() {
    if (this.type == 'preview') {
      return true
    }
    return false
  }

  @Emit('close')
  private close() {
    (this.$refs.form as ElForm).resetFields()
    this.show = false
  }

  public async open(type: string, id: number | null = null) {
    this.show = true
    this.type = type
    this.data = {
      configParam: undefined,
      configValue: undefined,
      note: undefined,
    }

    if (id) {
      const result = await QueryConfigById({ id })
      this.data = result
    }
  }

  public async save() {
    const f = this.$refs.form as ElForm
    f.validate(async (success: boolean) => {
      if (!success) {
        return
      }
      if (this.type == 'add') {
        await AddSysConfig(this.data)
      } else if (this.type == 'update') {
        await UpdateSysConfig(this.data)
      }
      Message.success('保存')
      this.close()
    })
  }
}
